import React from "react";
import "./App.css";
import { useEffect } from "react";
import { analytics } from './utiles/firebaseConfig'

import AllRoutes from "./config/allRoutes";
const App = () => {
  useEffect(() => {
    if (analytics) {
    }
  }, []);
  return (
    <AllRoutes />
  );
};

export default App;
